













import Vue from "vue";
import Component from "vue-class-component";
import { mask } from 'vue-the-mask';

@Component({
    directives: {
        mask,
    }
})
export default class DadosDdd extends Vue {

    public dddMask = '##';

    get ddd () {
        return this.$store.state.cotacao.ddd;
    }

    set ddd ( value ) {
        this.$store.commit("SET_DDD", value);
    }

    get errorDDD () {
        return this.$store.state.errors.ddd;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
